import { Box } from "@mui/material"
import { TextField } from "react-admin"

const TextModelComponents = () => {
  return (
    <Box>
      <Box>
        <TextField source="textModel.isSmallBusinessNotice" whiteSpace={'pre-line'} />
      </Box>
      <Box>
        <TextField source="textModel.recipientUstIdNotice" whiteSpace={'pre-line'} />
      </Box>
      <Box>
        <TextField source="textModel.reverseChargeNotice" whiteSpace={'pre-line'} />
      </Box>
      <Box>
        <TextField source="textModel.deliveryDateNotice" whiteSpace={'pre-line'} />
      </Box>
      <Box>
        <TextField source="textModel.dueDemand" whiteSpace={'pre-line'} />
      </Box>
      <Box mt={2}>
        <TextField source="textModel.terms" whiteSpace={'pre-line'} />
      </Box>
      <Box mt={2}>
        <TextField source="textModel.ending" whiteSpace={'pre-line'} />
      </Box>
    </Box>
  )
}

export default TextModelComponents